/**
 * @overview 问卷新增编辑页面
 * @author Ariel
 * @date 2020-3-13
 */
import React from 'react';
import {connect} from 'dva';
import moment from "moment";
import SurveyQuestionDetail from '../surveyQuestionDetail/surveyQuestionDetail'
import {framework_tool, component_tool, utils_tool} from '../../../../tool'
import SurveyAuth from "../surveyAuth/surveyAuth";

let {WizContainer, modelUtils, WizAvatarUpload, ossFileUtils} = framework_tool;
let {WizForm, WizButton, WizRow, WizCol, WizSpin, WizCustomSteps, WizNotice, Wizmessage} = component_tool;
let {Session} = utils_tool;

const steps = [
  {
    title: '问卷信息',
    content: 'First-content',
  },
  {
    title: '问卷设计',
    content: 'Second-content',
  },
  {
    title: '问卷设置',
    content: 'Last-content',
  },
];

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/biz/survey/surveyDetailUpd') {
      if (history.location.record) {
        record = history.location.record
        record.channelType = 'update'
        Session.set('surveyDetailUpd', record)
      } else {
        record = Session.get('surveyDetailUpd') || {}
      }
    }
    if (history.location.pathname === '/biz/survey/surveyDetailAdd') {
      if (history.location.record) {
        record = history.location.record
        record.channelType = record.channelType || 'create'
        Session.set('surveyDetailAdd', record)
      } else {
        record = Session.get('surveyDetailAdd') || {}
      }
    }
  }
  return record
}

class SurveyDetail extends WizContainer {

  componentName = 'surveyDetail';

  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      key: 'surveyDetail_' + new Date().getTime()
    }
    this.nextStepState = false;

    const {history} = props;
    let record = getParamRecord(history)
    let {id, channelType} = record
    this._type = channelType //来源渠道类型
    this._sourceId = id //来源渠道ID
    this.initialValue = record
    this.resetTime = new Date().getTime()
  }

  propsAndStateOnChange = {
    addSurvey: this._stepOne.bind(this),
  }

  _stepOne(nextProps, nextState) {
    if (nextProps.addSurvey.code == 1) {
      this.initialValue = nextProps.addSurvey.data
      WizNotice.success('保存成功');
      if (this.nextStepState) {
        this.nextStepState = false;
        nextState.current = this.state.current + 1;
        nextState.surveyId = nextProps.addSurvey.data.id
      } else {
        this.jumpPage('replace', '/biz/survey');
      }
    } else {
      this.nextStepState = false;
      WizNotice.error('保存失败：' + nextProps.addSurvey.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'surveyDate' && value != null && value != undefined) {
        fitterValues['startDate'] = moment(value[0]).format("YYYY-MM-DD HH:mm:00")
        fitterValues['endDate'] = moment(value[1]).format("YYYY-MM-DD HH:mm:59")
      } else if (key === 'look') {
        if (value == null || value == undefined || !value[0]) {
          fitterValues[key] = 0
        } else {
          fitterValues[key] = value[0]
        }
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    /**
     * 图片参数处理
     */
    let questionImg = fitterValues['questionImg']
    if (questionImg && questionImg.length) {
      fitterValues['img'] = questionImg[0]['fileId']
      delete fitterValues['questionImg']
    }
    return fitterValues;
  }

  /**保存问卷信息 */
  _saveSurvey(values) {
    let {record} = this.props && this.props.location
    let {channelType} = record
    let apiPath = 'survey/add';
    if (this.state.surveyId || channelType === "update") {
      apiPath = 'survey/update'
    }
    let fitterValues = this.fitterFieldsValue(values)
    this.doAction({
      path: apiPath,
      payload: {
        key: 'addSurvey',
        apiParams: {
          ...fitterValues,
        }
      }
    });

  }

  /**下一步 */
  nextStep() {
    this.nextStepState = true;
  }

  /**表单底部按钮 */
  formFooter = () => {
    return (
      <WizRow className="form-btns row-item">
        <WizCol span={24}>
          <WizButton title='保存并进入下一步' type='primary' htmlType='submit'
                     onClick={e => this.nextStep()}>保存并进入下一步</WizButton>
          <WizButton title='保存并返回' htmlType='submit'>保存并返回</WizButton>
          <WizButton title='重置' type='reset' onClick={e => this._onReset()}>重置</WizButton>
        </WizCol>
      </WizRow>
    )
  }

  /**根据步骤展示内容 */
  stepView(formProps) {
    if (this.state.current == 0) {
      return <WizForm className={'form-inline'} {...formProps} />
    } else if (this.state.current == 1) {
      return <SurveyQuestionDetail
        surveyId={this.state.surveyId}
        type={this._type}
        sourceId={this._sourceId}
        nextFunc={() => this.setState({current: this.state.current + 1})}
        backFunc={() => this.jumpPage('replace', '/biz/survey')}
        prevFunc={() => this.setState({current: this.state.current - 1})}
      />
    } else if (this.state.current == 2) {
      return <SurveyAuth
        surveyId={this.state.surveyId}
        type={this._type}
        sourceId={this._sourceId}
        initialValue={this.initialValue}
        nextFunc={() => this.jumpPage('replace', '/biz/survey')}
        prevFunc={() => this.setState({current: this.state.current - 1})}
      />
    } else {
      return null;
    }
  }

  _render() {
    const {surveyLoading} = this.props;
    let initialValue = this.initialValue;
    const {look} = initialValue;
    let initSurveyLook = [];
    if (look && look === 1) {
      initSurveyLook.push(1);
    }
    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: this.initialValue.id
        }
      },
      {
        title: '问卷标题',
        name: 'title',
        formItem: {
          maxLength: 50,
          placeholder: '问卷标题最多输入50个字',
          rules: [
            {
              required: true,
              message: '请输入问卷标题',
            },
            {
              pattern: /^[^\s]*$/,
              message: '问卷标题录入信息不能包含空格'
            }
          ],
          initialValue: this.initialValue.title
        }
      },
      {
        title: '问卷类型',
        name: 'type',
        dict: [
          { code: 0, codeName: '普通问卷' },
          { code: 1, codeName: '随堂问卷' },
          { code: 2, codeName: '回执问卷' },
          { code: 3, codeName: '满意度问卷' },
          { code: 4, codeName: '直播课堂问卷' }
        ],
        formItem: {
          rules: [{
            required: true,
            message: '请选择问卷类型',
          }],
          initialValue: this.initialValue.type,
          type: 'select'
        }
      },
      {
        title: '问卷时间',
        name: 'surveyDate',
        dataIndex: 'surveyDate',
        formItem: {
          type: 'date~',
          showTime: true,
          format: 'YYYY-MM-DD HH:mm',
          rules: [
            {
              required: true,
              message: '请选择问卷时间',
            }
          ],
          initialValue: this.initialValue.startDate && this.initialValue.endDate && [moment(this.initialValue.startDate), moment(this.initialValue.endDate)]
        },
      },
      {
        name: 'look',
        formItem: {
          type: 'checkbox',
          initialValue: initSurveyLook,
          dict: [
            {code: 1, codeName: '提交后可查看统计结果'}
          ],
          formItemLayout: {
            wrapperCol: {span: 14, offset: 6},
          }
        }
      },
      {
        title: '上传封面',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form
            return (
              <>
                {getFieldDecorator('questionImg', {
                  initialValue: (this.initialValue && this.initialValue.img) ? [
                    {fileId:this.initialValue.img}
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    // aspectRatio={800 / 320}
                    aspectRatio={1.93}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过1MB!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        }
      },
      {
        title: '问卷说明',
        name: 'intro',
        dataIndex: 'intro',
        formItem: {
          type: 'textarea',
          placeholder: '介绍最多输入300个字符',
          maxLength: 300,
          initialValue: this.initialValue.intro
        },
      }
    ]

    let onSubmit = this._saveSurvey.bind(this);
    let formProps = {
      ref: 'form',
      loading: surveyLoading,
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: this.formFooter(),
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 15}
      }
    }

    const wizCustomStepsProps = {
      header: steps,
      current: this.state.current,
      content: this.stepView(formProps),
      footer: null
    }

    return <WizCustomSteps {...wizCustomStepsProps} />
  }

  _onReset() {
    this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields()
  }
}

const mapStateToProps = (state, ownProps) => {
  const {survey} = state;
  const addSurvey = modelUtils.getModelEntity(survey, 'addSurvey');
  const load = modelUtils.getLoadingState(state, ['survey']);
  return {
    addSurvey: addSurvey,
    ...load
  }
};

export default connect(mapStateToProps)(SurveyDetail);
